

























import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import CampaignCard from "@/components/CampaignCard.vue";
import NewCampaignCard from "@/components/admin/NewCampaignCard.vue";

@Component({
  components: {
    CampaignCard,
    NewCampaignCard,
  },
  computed: mapGetters(["allCampaigns"]),
})
export default class AdminCampaignOverview extends Vue {}
